import React, { Component } from "react";

import "./ActivityIndicator.css";

class ActivityIndicator extends Component {
  render() {
    return (
      <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    );
  }
}

export default ActivityIndicator;
